// extracted by mini-css-extract-plugin
module.exports = {"img":"CastCard_img__O9BRq","poster":"CastCard_poster__1_Sc-","cover":"CastCard_cover__yUj1z","name":"CastCard_name__D7XAF","name-text":"CastCard_name-text__3qKCy"};